var map = {
	"./Tadpole.jpg": 570,
	"./b0xx.webp": 5973,
	"./bubblebox.PNG": 681,
	"./crosscut.webp": 1335,
	"./fightbox.webp": 8988,
	"./frame1heavy.webp": 3986,
	"./frame1light.webp": 2921,
	"./glyph.PNG": 9410,
	"./gramslim.webp": 5093,
	"./lbx.webp": 4167,
	"./schism.jpg": 4804,
	"./smashbox.webp": 1578,
	"./superslab.png": 7630
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;